import React from 'react';
import { Alert, AppBar, Box, Chip, LinearProgress, ListItem, Stack } from "@mui/material";
import { green, grey } from '@mui/material/colors';
import { useNavigate } from 'react-router-dom';
import { useBookmarkNavigation } from '../types/cutterState';
import { useAppSelector } from '../appHooks';
import { SearchParameters, setFavorite } from "../redux/cutterSearchAPI";
import { useGetCutterHistoryBySerialQuery } from "../redux/cutterHistoryAPI";
import store, { RootState } from "../store";
import LogToDB from '../types/dbLogs';
import CutterDetailsHistory from "./CutterDetailsHistory";
import HelpIcon from '../help/HelpIcon';

export const Bookmarks: React.FC = () => {
    const defaultSelect: string = '';
    const [select, setSelect] = React.useState(defaultSelect);
    const [verticalTabValue, setVerticalTabValue] = React.useState('connexion');
    const search : SearchParameters = useAppSelector((state: RootState) => state.persistedSearchReducer);

    const navigate = useNavigate();
    const { serialNumber: urlSerialNumber, tab: urlTab } = useBookmarkNavigation();
    const selectCutter = (serialNumber: string): void => {
        setSelect(serialNumber);
        navigate(`/bookmarks?serialnumber=${encodeURIComponent(serialNumber)}`);
        void LogToDB('bookmark', serialNumber);
    };

    React.useEffect(() => {
        if (urlSerialNumber) setSelect(urlSerialNumber);
        if (urlTab) setVerticalTabValue(urlTab);
    }, [urlSerialNumber, urlTab]);

    
    const results: ReturnType<typeof useGetCutterHistoryBySerialQuery> = useGetCutterHistoryBySerialQuery(select, {
        skip: select === defaultSelect,
    });

    return (
        <Stack direction="column">
            <AppBar position="static"
                color="default"
                elevation={0}
                sx={{ 
                    borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
                    backgroundColor: (theme) => theme.palette.mode === 'light' ? grey[100] : '#252525',
                    marginY: 0, 
                    minHeight: 0 
                }}>
            <Box component="ul" sx={{
                        display: "flex", justifyContent: "left", flexWrap: "nowrap", listStyle: "none",
                        padding: 0.5, marginY: 1, overflow: "auto"
                    }} >
                        {
                            search.favorites.map((serialNumber: string) => {
                                return (

                                    <ListItem key={serialNumber} sx={{ width: 'auto', paddingX: 0.5 }}>
                                        <Stack direction="row" alignItems="center" spacing={0.5}>
                                            <Chip
                                                label={serialNumber}
                                                sx={{ 
                                                    margin: 0.5, 
                                                    bgcolor: (theme) => serialNumber === select 
                                                        ? (theme.palette.mode === 'light' ? green[700] : green[800])
                                                        : (theme.palette.mode === 'light' ? 'white' : theme.palette.background.paper),
                                                    color: (theme) => serialNumber === select ? 'white' : 'inherit',
                                                    borderColor: (theme) => serialNumber === select 
                                                        ? (theme.palette.mode === 'light' ? green[700] : green[800])
                                                        : undefined
                                                }}
                                                variant="outlined"
                                                onClick={() => selectCutter(serialNumber)}
                                                onDelete={() => store.dispatch(setFavorite(serialNumber))}
                                            />
                                            {serialNumber === select && <HelpIcon helpContext="bookmark-remove" placement="right" size="small" />}
                                        </Stack>
                                    </ListItem>
                                );
                            })}
                    </Box>
            </AppBar>

            <LinearProgress color='secondary' sx={{ display: results.isFetching ? 'block' : 'none' }} />

            <Alert severity="info" sx={{ display: results.status === 'uninitialized' ? 'flex' : 'none' }}>Select a bookmark to display cutter history</Alert>
            <Alert severity="info" sx={{ display: results.status === 'pending' ? 'flex' : 'none' }}>Loading cutter {select} history...</Alert>
            <CutterDetailsHistory 
                serialNumber={select} 
                verticalTabValue={verticalTabValue}
                onVerticalTabChange={setVerticalTabValue}
                sx={{ display: results.status === 'pending' ? 'none' : 'flex', width: '100%' }} 
            />

        </Stack>)
}

export default Bookmarks